import React from 'react';

export const governingLawAndJurisdictionMessage = {
  value: 'Governing Law and Jurisdiction',
  list: [
    {
      value: (
        <>
          The Terms and Conditions and any dispute or matter arising from or
          incidental to the use of the Site shall be governed by and construed
          in accordance with the laws of Singapore. Any dispute, controversy or
          claim arising out of or in connection with the Terms and Conditions,
          including any question regarding its existence, validity, breach or
          termination, shall be referred to and finally resolved by arbitration
          in Singapore at the Singapore International Arbitration Centre
          (“SIAC”) or at such other venue in Singapore as the parties concerned
          may agree in writing in accordance with the SIAC Rules. A tribunal
          shall consist of a single arbitrator to be appointed by the chairman
          of the SIAC. The decision of the tribunal shall be final and binding
          on the parties concerned. The language of the arbitration shall be
          English. The parties concerned undertake to keep the arbitration
          proceedings and all information, pleadings, documents, evidence and
          all matters relating thereto confidential.
        </>
      ),
    },
    {
      value: (
        <>
          In the event of any breach of the Terms and Conditions by a party, the
          other party shall be entitled to remedies in law and equity as
          determined by arbitration.
        </>
      ),
    },
  ],
};
